
import React, {Component} from 'react';
import {Modal,Button,ButtonGroup,DropdownButton,MenuItem,Label} from 'react-bootstrap'
import {Box} from 'reactjs-admin-lte'

class QuotationDocModal extends Component {

  constructor(...args){
    super(...args)
    
    this.state = {loading:false}
  }

  componentDidMount(){
    
  }

  render(){
    let {show,fileName} = this.props
    let {loading} = this.state
    let title ='ใบเสนอราคา '
    
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="fullwidth-dialog">
        <Modal.Header closeButton={false}>
          <Modal.Title style={{display:'inline'}}>{title}</Modal.Title>
          
        </Modal.Header>
        <Modal.Body>   
          <Box loading={loading}>                            
                    
          </Box>

        </Modal.Body>
        
      </Modal>
    )
  }
}

QuotationDocModal.defaultProps = {
  show : false
}

export default QuotationDocModal;





// WEBPACK FOOTER //
// ./src/view/qo/QuotationDocModal.js